/* 布局 */
//前台
import Layout from "@views/layout";

const goodswarehouseRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "goodswarehouse/list",
        name: "GOODSWAREHOUSE",
        meta: {
            title: "商品库存管理",
            keepAlive:true
        },
        component: () => import("@views/business/goodswarehouse/index.vue"),
    },
        ],
};

export default goodswarehouseRouter;
